import { render, staticRenderFns } from "./LandingPassengersDataPage.vue?vue&type=template&id=4c5ab68a&scoped=true&"
import script from "./LandingPassengersDataPage.vue?vue&type=script&lang=js&"
export * from "./LandingPassengersDataPage.vue?vue&type=script&lang=js&"
import style0 from "./LandingPassengersDataPage.vue?vue&type=style&index=0&id=4c5ab68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ab68a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5ab68a')) {
      api.createRecord('4c5ab68a', component.options)
    } else {
      api.reload('4c5ab68a', component.options)
    }
    module.hot.accept("./LandingPassengersDataPage.vue?vue&type=template&id=4c5ab68a&scoped=true&", function () {
      api.rerender('4c5ab68a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/data/landingPassengersData/LandingPassengersDataPage.vue"
export default component.exports